import React, { useCallback, useEffect, useState } from 'react'

//Ui
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Breadcrumb from 'ui/Breadcrumb'
import Heading from 'ui/Heading'
import Skeleton from 'ui/Skeleton'
import Footer from 'ui/Footer'

//Components
import LessorUpdateProfile from 'components/Lessor/LessorUpdateProfile'
import LessorChangePassword from 'components/Lessor/LessorChangePassword'

// Models
import LessorModel from 'models/Lessor'
import useMounted from 'use/mounted'
import { useParams } from 'react-router'

// Api
import { getLessorInfo } from 'api/lessor'

// Path
import { PATH_MY_ACCOUNT } from 'routes/paths'

const breadcrumbs = [
  {
    label: 'Account & payments',
    path: PATH_MY_ACCOUNT,
  },
  {
    label: 'View my profile',
  },
]

const Profile = () => {
  const isMounted = useMounted()
  const { lessorName, companyId, vendorId } = useParams()
  // State
  const [loading, setLoading] = useState(false)
  const [profile, setProfile] = useState(new LessorModel())
  const fetchLessor = useCallback(() => {
    setLoading(true)
    getLessorInfo({ lessorName, companyId, vendorId })
      .then((data) => {
        if (isMounted.current) {
          setProfile(data)
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [companyId, isMounted, lessorName, vendorId])

  useEffect(() => fetchLessor(), [fetchLessor])

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <Heading paddingTop={0} size={30}>
          View my profile
        </Heading>
        <Skeleton loading={loading}>
          <LessorUpdateProfile
            profile={profile}
            onLessorUpdated={fetchLessor}
          />
        </Skeleton>
        <br />
        <LessorChangePassword />
      </Container>
      <Footer />
    </>
  )
}

export default Profile
